<template>
<Suspense>
  
<div class ="col">
  <div class="row px-2 d-flex flex-row">
    <div class="" :style="{maxWidth:'950px'}">
      <h6>
      <span >
            {{ questions.title }}
          </span>
    </h6>
    </div>
    
    <div class="">
    <div @mouseenter="openTooltip" @mouseleave="closeTooltip"  :style="{width:20+'px',height:20+'px',cursor: 'default',maxWidth:'800px'}" class="ml-1 rounded-circle text-center align-top bgnscblue small infohover"><b> ? </b></div>
    <span :id='avg' :style="{position:'fixed'}" class='border rounded bgnscblue p-2 small transit' >{{tooltip[0]}}<br><br>{{tooltip[1]}}</span>
    </div>
  </div>
  <div class="row">
    <!-- <h6>{{questions.title}}</h6> <div @mouseenter="openTooltip" @mouseleave="closeTooltip"  :style="{width:20+'px',height:20+'px',cursor: 'default'}" class="ml-2 rounded-circle text-center align-top bgnscblue infohover small"><b> ? </b> -->
    <!-- </div><span :id='avg' :style="{position:'fixed', maxWidth:350+'px'}" class='border rounded bgnscblue p-2 small transit' >{{tooltip[0]}}<br><br>{{tooltip[1]}}</span> -->
    <br><p class="small ml-5" v-show="questions.responses[data]==='Unsure'"><i>You selected 'Unsure' as your answer, and will not see a bubble on the visualization below.</i></p>
  </div>
 
 <!-- <div class="row " v-for="(ele,i) in benchmark" :key="i">
    
    <div class="col-2"></div>
    <div class="col-8">
      <div class="row">
        
    <apexchart 
      :height="150"
      :width ="700"
      type="bar"
      :options="makeOptions(i)"
      :series="makeSeries(ele)"
    />
    </div>
    </div>
    
    
  </div> -->
  <div class="row">
    <div class="col-2"></div>
      <span v-if="responses[data] != 'Unsure'" :id='avg+1' :style="{position:'fixed'}" class='border rounded bgnscgreen p-2 small transit' >You selected: {{categories[data]}}</span>
      <span v-else  :id='avg+1' :style="{position:'fixed'}" class='border rounded bgnscgreen p-2 small transit' >You selected: Unsure</span>
    <div class="col">
      <div class="row">
       <div class="col"> <div @mouseenter="annoHover" @mouseleave="annoLeave"><apexchart  type="line" :options="optionsLine" height="150" :series="series"></apexchart></div> </div>
      </div>
     
    </div>
    
  </div>
  </div>
  </Suspense>
</template>
<script>
import store from "../../store"

export default {
  props: ['data', 'questions', 'benchmark','test','avg', 'tooltip','chartNum'],
  data: function () {
    return {
      
      // range: this.makeRange(this.benchmark2),
      popover:false,
      annotationPop: false,
      responses: this.questions.responses,
      categories: this.categoryTrim(this.questions.responses),
      values: [],
      
      yourAnswer: this.questions.ID == 12 ? (4-this.data)*2.5 : (5-this.data)*2,
      chart: {
        options: {
          }},
          optionsLine:{
  chart: {
    type: 'line',
    width:500,
    height:150,
    selection:{
      enabled:false
    },
    yaxis: {
      tickAmount:2,
    },
    toolbar: {
              show: false,
            },
  },
  colors:['#003a5c'],
  tooltip:{
    enabled:false
  },
  grid:{
    show:false,
  },
  yaxis:{
    min: 2,
    max: 4,
    labels:{
      show:false,
    },
    axisTicks:{
      show: false,
    },
    crosshairs:{
      show:false
    }
  },
  xaxis: {
    type:'numeric',
    
    
    labels:{
      show:false,
    },
    axisTicks:{
      show: false,
    },
    axisBorder: {
          show: false,
    }
  },
  responsive:[{
    breakpoint:"425px",
    options: {
        chart: {
          width: '100px',
          height: '100px'
        }
    }
  }],
  annotations: {
 
  points: [
  {
    x:this.avg,
    y: 3,
    marker: {
      size: 13,
      shape:'square',
      strokeColor:'#006bab',
      fillColor: '#FFFFFF'
    },
    label: {
      borderColor: '#FFFFFF',
      text: 'Average',
      style:{
        fontFamily: "Sans-serif",
        fontSize: "12px"
      },
      offsetY: 45,
      
      
    }
  },
  {
    x:9.9,
    y: 3,
    marker: {
      size: 10,
      shape:'circle',
      strokeColor:'#003a5c',
      fillColor: "#FFFFFF",
    },
    label: {
      borderColor: '#FFFFFF',
      text: this.categoryTrim(this.questions.responses)[0],
      style:{
        fontFamily: "Sans-serif",
        fontSize: "12px"
      },
      offsetY:45
    }
  },
  {
    x:1.1,
    y: 3,
    marker: {
      size: 10,
      shape:'circle',
      strokeColor:'#003a5c',
      fillColor: "#FFFFFF",
    },
    label: {
      borderColor: '#FFFFFF',
      text: this.categoryTrim(this.questions.responses)[this.questions.responses.length-1] == 'Unsure' ? this.categoryTrim(this.questions.responses)[this.questions.responses.length-2] : this.categoryTrim(this.questions.responses)[this.questions.responses.length-1],
      style:{
        fontFamily: "Sans-serif",
        fontSize: "12px"
      },
      offsetY:45
    }
  },this.makeAnnotation()
]
        }
      },
      series: [{
    name: 'sales',
    data: [3,3,3,3,3,3,3,3,3,3]
  }],

    }
  },
  methods: {
    showModal(modal, data) {
      store.showModal(modal, data);
    },
    hideModal() {
      store.hideModal();
    },
    findCategories(question){
      let obj = {}
      for(let key in question){
        obj[`cat${key}`] = this.categoryTrim(question[key].q) 
      }
      return obj
    },
    categoryTrim(arr){
      let temp = []
      for( let str of arr){
        temp.push(str.lastIndexOf("(") > 0 ? str.slice(0,str.lastIndexOf("(")).trim() : str.lastIndexOf("?") > 0 ? str.slice(0,str.lastIndexOf("?")).trim() : str.trim())
      }
      
      return temp
    },
    calculateHeight(i){
      let height = (100-18)/this.benchmark.length
      
      return i == 0 ? height : height -18
      

    },
    chooseColors(int){

      return int < 5 ? ['#003a5c', '#006bab','#00853e','#72bf44'] : ['#003a5c', '#006bab','#00853e','#72bf44', '#6dcff6']
    },
    processData(arr) {
      // let mid = Math.floor(arr.length / 2)
      let total = arr.reduce((x, y) => x + y, 0)
      return arr.map(x => (x / total) * 100) //.map((x, i) => i < mid ? -x : x)

    },

    makeSeries(ele) {
      let data = this.processData(ele)
      let temp = Object.values(this.questions.responses)
      temp.length == 6 ? temp.pop() : true;
    
      let arr = this.categoryTrim(temp).map((x, i) => { return { name: x, data: [data[i]] } })
      
      return arr
      
    },
    makeRange(arr) {

      let min = 0, max = 0, mids = [], ranges = [];

      for (let ele of arr) {
        let temp = this.processData(ele)
        let neg = 0, pos = 0;
        let mid = temp[Math.floor(arr.length / 2)] / 2
        mids.push(mid)

        for (let i of temp) {
          if (i < 0) {
            neg += i

          } else {
            pos += i

          }

        }
        if ((neg - mid) < min) {
          min = neg - mid
        }
        if ((pos - mid) > max) {
          max = pos - mid
        }
      }

      for (let ele of mids) {

        ranges.push([ele + min - 10, ele + max + 10])
      }

      return ranges

    },
    makeOptions(index) {
      
      
      return {
          chart: {
            type: 'bar',
            stacked: true,
            stackType:'100%',
            width:500,
            toolbar: {
              show: false,
            },
          },
          legend: { // if first chart show
            position: 'bottom',
            show: parseInt(index) < 1 ? true : false,
            
          },
          // responsive: [
          //   {
          //     breakpoint: 1000,
          //     options: {
          //       chart: {
          //         width: 300,
          //         height: 100
          //       },
          //     }
          //   }
          // ],
          colors: this.chooseColors(this.benchmark[0]),
          plotOptions: {
            bar: {
              horizontal: true,
              // barHeight: '70%',
              dataLabels: {
            hideOverflowingLabels: false
        }
            },
            dataLabels:{
              enabled:true,
              offsetX: 30
            }
          },
          stroke: {
            width: 1,
            colors: ["#fff"]
          },
          dataLabels:{
              enabled:true,
              offsetX: 0
            },
          grid: {
            xaxis: {
              lines: {
                show: false
              },

            },
            yaxis:{
              lines: {
                show: false
              },
            }
          },
          yaxis: {
            // min: -5,
            // max: 5,
            tickPlacement: 'on',
            title: {
              // text: 'Age',
            },
            axisBorder: {
      show: false
    },

          },
          tooltip: {
            shared: false,
            x: {
              formatter: function (val) {
                return val
              }
            },
            y: {
              formatter: function (val) {
                return Math.abs(val).toFixed(0) + "%"
              }
            }
          },
          xaxis: {
            categories:[''],
            // min: this.makeRange(this.benchmark)[index][0],
            // max: this.makeRange(this.benchmark)[index][1],
            labels: {
              show: false,
              // cssClass: 'apexcharts-xaxis-label',
            },
            tickAmount: 1,
            tickPlacement: 'between',
            axisTicks: {
              show: false
            },
            axisBorder: {
      show: false
    },

          },
        }
    },
    makeAnnotation(){
      const unsure = this.questions.responses[this.data]==='Unsure'? false:true
      return {
        x:unsure ? (this.questions.ID == 12 ? (4-this.data)*2.5 : (5-this.data)*2) : 5,
        y: 3,
        marker: {
          size: unsure ? 10:1,
          shape:'circle',
          strokeColor:unsure ? '#00843d' : '#003a5c',
          fillColor: '#FFFFFF'
        },
        label: {
          borderColor: '#FFFFFF',
          text: unsure ? 'Your Answer' : '',
          style:{
            fontFamily: "Sans-serif",
            fontSize: "12px"
          },
          
          
        }
      }
    },
    annoHover(){
      
      // console.log(' anno tooltip:::')
      this.annotationPop=true
      let annotation = document.getElementsByClassName('vue-apexcharts')[this.chartNum].children[0].children[0].children[0].children[8].children[9]
      let annoLocation = annotation.getBoundingClientRect()
      
      
      let tooltip = document.getElementById(`${this.avg+1}`)
      annotation.onmouseenter = ()=>tooltip.classList.toggle('transit')
      annotation.onmouseleave = ()=>tooltip.classList.toggle('transit')
      // annotation.addEventListener("mouseenter",()=>tooltip.classList.toggle('transit'),true)
      // annotation.addEventListener("mouseleave",()=>tooltip.classList.toggle('transit'),true)
      let x = annoLocation.x
      let y = annoLocation.y
      
      
      
      tooltip.style.left = x-40+'px'
      tooltip.style.top = y-60+'px'
      // console.log(x,y)
    },
    annoLeave(){
      // let annotation = document.getElementsByClassName('vue-apexcharts')[this.chartNum].children[0].children[0].children[0].children[8].children[9]
      // let tooltip = document.getElementById(`${this.avg+1}`)
      // annotation.removeEventListener("mouseenter",()=>tooltip.classList.toggle('transit'),true)
      // annotation.removeEventListener("mouseleave",()=>tooltip.classList.toggle('transit'),true)
      
      this.annotationPop=false
    },
    openTooltip(event) {
      this.popover=true
      let x = event.clientX
      let y = event.clientY
      let tooltip = document.getElementById(`${this.avg}`)
      tooltip.classList.toggle('transit')
      
      tooltip.style.zIndex = 99
      tooltip.style.left = x+15+'px'
      tooltip.style.top = y+15+'px'
      
    },
    closeTooltip(){
      let tooltip = document.getElementById(`${this.avg}`)
      tooltip.classList.toggle('transit')
     
      this.popover=false
    }
    
  },
  mounted() {
      
      
    
    const svgs = document.querySelectorAll('svg')
    // console.log(svgs)
    svgs.forEach((element) => element.style.overflow = 'visible !important')
  },
  setup(){
    // let temp = this.test[0]
    //   this.benchmark2 = Object.values(temp).map(x=>x)
    //   this.average = (this.benchmark2.map((x,i)=> x*i).reduce((p,c)=>p+c,0))/(this.benchmark2.reduce((p,c)=>p+c,0)) * 10 / this.benchmark2.length
    //   console.log (this.benchmark2,this.average)
    //   // let x = []
    //   for(let key in temp) {
    //     console.log(key)
    //     // x.push(temp[key])
    //   }

  }

}
</script>